// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2X0DF","footer":"ChangeClinic_footer__3IS09"};